module.exports = __webpack_public_path__ + "img/hrc-about.5a95f709.webp";